export default __webpack_public_path__ + "static/media/leader-2.a91b1052.svg";